module.exports = __webpack_public_path__ + "@/assets/img/050-girl-26.a92216ab.svg";